// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"_9400a595a7--wrapper--fRK2O"};